import {Component, Input, OnInit} from '@angular/core';
import {Device} from '../../../../../models/device';
import {ApiService} from '../../../../api.service';
import {DataStorageService} from '../../../../data-storage.service';

@Component({
  selector: 'app-device-catalogue',
  templateUrl: './device-catalogue.component.html',
  styleUrls: ['./device-catalogue.component.scss']
})
export class DeviceCatalogueComponent implements OnInit {

  constructor(
    private dataStorageService: DataStorageService,
    private api: ApiService) {
    this.devices = [];
  }

  @Input()
  set categoryID(id: number) {
    this.devices = [];
    id = id === undefined ? this.dataStorageService.categoriesGlobal[0].id : id;
    this.api.getDevices(0, id).then((data) => {
      this.devices = data;
    });
  }

  devices: Device[];

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/peoplephone-devices-data-base/device-catalogue/device-catalogue.component.ts